import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    currentUser: null,
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user;
    },
    deleteCurrentUser(state) {
      state.currentUser = null;
    },
  },
  getters: {
    currentUser: (state) => {
      return state.currentUser;
    },
  },
});
